import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Block,
  Content,
  StyledImage,
  StyledLink,
  SectionFooter,
} from './styles';

const Questions = ({ data, className }) => {
  if (!data) return null;
  const {
    sectionTitleHtml,
    items,
    columnAlignment,
    colourOverrideText,
    colourOverrideBackground,
    titleHtml,
    buttonLink,
    buttonText,
    buttonType,
    ariaLabelButton,
    queryStringButton,
    backgroundImage,
  } = data;

  const textColor = colourOverrideText
    ? `text-${colourOverrideText.toLowerCase()}`
    : 'text-Light';

  const style =
    columnAlignment && columnAlignment === 'Left' ? 'left-aligned-columns' : '';

  return (
    <Wrapper
      className={[className, style, textColor]}
      colourOverrideBackground={colourOverrideBackground}
      background={backgroundImage ? backgroundImage.url : null}
    >
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(sectionTitleHtml)}
        <Columns>
          {items.map(
            (
              {
                itemImage,
                imageItemSharp,
                itemHeadingHtml,
                itemSubHeadingHtml,
                itemBodyCopyHtml,
                cta,
                ctaText,
                buttonType: itemButtonType,
                ariaLabel,
                queryString,
              },
              index
            ) => {
              return (
                <Block key={`question-item-${ctaText}-${index.toString()}`}>
                  {imageItemSharp && (
                    <StyledImage src={imageItemSharp} alt={itemImage.altTag} />
                  )}
                  <Content>
                    {ReactHtmlParser(itemHeadingHtml)}
                    {ReactHtmlParser(itemSubHeadingHtml)}
                    {ReactHtmlParser(itemBodyCopyHtml)}
                    {cta && ctaText && (
                      <StyledLink
                        to={`${cta.url}/`}
                        className={itemButtonType}
                        ariaLabel={ariaLabel}
                        queryString={queryString}
                      >
                        {ctaText}
                      </StyledLink>
                    )}
                  </Content>
                </Block>
              );
            }
          )}
        </Columns>
        {(titleHtml || buttonText) && (
          <SectionFooter>
            {ReactHtmlParser(titleHtml)}
            {buttonLink && buttonText && (
              <Link
                to={buttonLink.url}
                className={buttonType}
                ariaLabel={ariaLabelButton}
                queryString={queryStringButton}
              >
                {buttonText}
              </Link>
            )}
          </SectionFooter>
        )}
      </StyledContainer>
    </Wrapper>
  );
};

Questions.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

Questions.defaultProps = {
  className: null,
};

export default Questions;
